<template>
  <div
    ref="cont"
    class="trainer-ranges-hand-strength eqchart"
    :class="[{ 'eqchart_skeleton no-events': skeleton }]"
  >
    <div
      class="eqchart_content gw_overlay"
      @click="$emit('click')"
      @mousedown="$emit('mousedown')"
    >
      <div class="gw_overlay_content">
        <i class="mdi mdi-arrow-expand text-big icon_btn icon_btn_active pa-2 clr-grey"></i>
      </div>
      <ChartSvg
        class="eqchart_svg"
        :ipPointsXY="ipPointsXY"
        :oopPointsXY="oopPointsXY"
        :handsIPPointsXY="handsIPPointsXY"
        :handsOOPPointsXY="handsOOPPointsXY"
        :pointsActiveXY="pointsActiveXY"
        :pointsPinnedXY="pointsPinnedXY"
        :style="`${styleAxes}${styleSvg || ''}`"
        style="--content-opacity: var(--chart-opacity); --svg-radius: 4px"
      />
      <ChartLegendPlayers
        class="eqchart_legend"
        :style="styleLegend"
        :oopPlayer="oopPlayer"
        :ipPlayer="ipPlayer"
        style="--legend-inset: 0.5rem auto auto 0.5rem"
      />
    </div>
  </div>
</template>

<script>
import eq_chart_mix from '@/components/Charts/LineCharts/eq_chart_mix'
import ChartSvg from '@/components/Charts/LineCharts/ChartSvg'
import ChartLegendPlayers from '@/components/Charts/LineCharts/ChartLegendPlayers'

export default {
  name: 'EquityChart',

  components: {
    ChartSvg,
    ChartLegendPlayers,
  },
  mixins: [eq_chart_mix],
  props: {
    hero: Object,
    opponent: Object,
    handInfo: Object,
    skeleton: Boolean,
    // learningMode: Boolean,
    hands: Array,
    rangeKey: String,
    handsHero: Array,
    handsOpponent: Array,
    handsActiveHero: Array,
    player: String,
    handsActiveOpponent: Array,
    handsPinnedHero: Array,
    handsPinnedOpponent: Array,
    styleLegend: String,
    styleAxes: { default: () => '--axis-space: 0rem;' },
    styleSvg: String,
    simpleView: Boolean,
  }, 
 emits: ['click','mousedown'],
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.eqchart {
  flex: 1;
  position: relative;
  &_content {
    position: relative;
    height: 9rem;
    z-index: 1;
  }
  .eqchart_svg {
    --chart-opacity: 1;
    height: 100%;
  }
  &_skeleton {
    .eqchart {
      &_svg {
        --chart-opacity: 0;
      }
      &_legend {
        display: none;
      }
    }
  }
  &_svg {
    z-index: 2;
  }
}
</style>
